/**
 * Typed search params for the `/invoices` route. The archived toggle lives in
 * the URL so it is deep-linkable AND compile-checked (the reports `searchParams`
 * pattern). TanStack Router validates the raw URL params through
 * `validateInvoicesSearch` on every navigation.
 *
 * `?show_archived=1` flips the list to archived invoices (legacy parity —
 * `InvoicesPage` `showArchived`). The coarse endpoint owns the filtering; the
 * SPA only carries the flag.
 */

export interface InvoicesSearch {
  show_archived?: boolean;
}

/** Coerce a raw URL value into a boolean (`1`/`true` → true). */
function asBool(value: unknown): boolean {
  return value === true || value === '1' || value === 'true';
}

/**
 * TanStack Router `validateSearch` for the invoices list route. Only keeps the
 * archived flag when truthy so the canonical URL stays clean (`/invoices` vs
 * `/invoices?show_archived=1`).
 */
export function validateInvoicesSearch(raw: Record<string, unknown>): InvoicesSearch {
  return asBool(raw.show_archived) ? { show_archived: true } : {};
}
